module.exports = __webpack_public_path__ + "static/media/Melissa Brick Wall_1.66fc56f1.jpg";